@if (ready() && isInSelfServeArea()) {
  @for (job of notifications().slice().reverse(); track job.callUuid) {
    <qai-alert
      [kind]="statusOf(job.serverStatus, job.reason) === CallRefinementStatus.Updated ? 'success' : 'error'"
      [title]="bannerTitle(job) | transloco"
      (closeClick)="dismiss(job.callUuid)"
    >
      {{ bannerBody(job) | transloco: { name: job.callName ?? '' } }}
      <div class="banner-actions">
        <button
          qai-button
          kind="tertiary-text"
          size="small"
          (click)="dismiss(job.callUuid)"
        >
          {{ "simulationBuilder.DISMISS" | transloco }}
        </button>
        <button
          qai-button
          kind="tertiary-text"
          size="small"
          class="view-simulation-link"
          (click)="handleViewSimulationClick(job.callUuid, job.moduleUuid, job.simulationStatus)"
        >
          {{ "simulationBuilder.VIEW_SIMULATION" | transloco }}
        </button>
      </div>
    </qai-alert>
  }
}
